import React from 'react';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Typography, Box, Tooltip, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: "#fff",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 500,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9"
    }
}))(Tooltip);

const useStyles = makeStyles(() => ({
    root: {},
    typoColor: {},
    greenTick: {
        color: '#32CD32'
    }
}));

const hasValidLength = (password) => {
    if (password !== null && password !== undefined && password !== "" && password.length > 11) {
        return true;
    }

    return false;
}

const hasNumber = (password) => {
    if (password !== undefined && password !== null && password.length > 0) {
        let pswd = password.replace(/[0-9]/g, "");
        if (pswd.length !== password.length) {
            return true;
        }
    }

    return false;
}

const hasLowerCaseAlphabet = (password) => {
    if (password !== undefined && password !== null && password.length > 0) {
        let pswd = password.replace(/[a-z]/g, "");
        if (pswd.length !== password.length) {
            return true;
        }
    }

    return false;
}

const hasUpperCaseAlphabet = (password) => {
    if (password !== undefined && password !== null && password.length > 0) {
        let pswd = password.replace(/[A-Z]/g, "");
        if (pswd.length !== password.length) {
            return true;
        }
    }

    return false;
}

const hasUpperAndLowerAplhabet = (password) => {
    if (password !== undefined && password !== null && password.length > 0) {
        return (hasLowerCaseAlphabet(password) && hasUpperCaseAlphabet(password))
    }

    return false;
}

const hasSpecialCharacter = (password) => {
    if (password !== undefined && password !== null && password.length > 0) {
        let pswd = password.replace(/[\!\@\#\$\%\^\&\*\(\)\_\-\+]/g, "");
        if (pswd.length !== password.length) {
            return true;
        }
    }

    return false;
}

const notContainsUserName = (password, email) => {
    if (email === undefined || email === null || email === "" || password === undefined || password === null || password === "") {
        return false;
    }

    if (email !== undefined && email !== null && email.length > 0 &&
        password !== undefined && password !== null && password.length > 0) {
        password = password.toLowerCase();
        if (password.indexOf(email) > -1) {
            return false;
        }

        if (email.indexOf("@") > 0) {
            let username = email.split("@")[0];
            if (password.indexOf(username) > -1) {
                return false;
            }
        }
    }

    return true;
}

const getPassowrdToolTip = (password, email) => {
    const classes = useStyles();
    return (
        <Box component="div">
            <Typography color="secondary" variant="h4">
                Password Guide
          </Typography>
            <List>
                <ListItem >
                    <ListItemIcon>{notContainsUserName(password, email) ? <CheckCircleIcon className={classes.greenTick} /> : <FiberManualRecordIcon color="secondary" />}</ListItemIcon>
                    <ListItemText primary={'Password cannot be the same as the user name,'} />
                </ListItem>
                <ListItem >
                    <ListItemIcon>{hasValidLength(password) ? <CheckCircleIcon className={classes.greenTick} /> : <FiberManualRecordIcon color="secondary" />}</ListItemIcon>
                    <ListItemText primary={'be at least 12 characters long,'} />
                </ListItem>
                <ListItem >
                    <ListItemIcon>{hasUpperAndLowerAplhabet(password) ? <CheckCircleIcon className={classes.greenTick} /> : <FiberManualRecordIcon color="secondary" />}</ListItemIcon>
                    <ListItemText primary={'contains 1 upper case and 1 lower case letter,'} />
                </ListItem>
                <ListItem >
                    <ListItemIcon>{hasNumber(password) ? <CheckCircleIcon className={classes.greenTick} /> : <FiberManualRecordIcon color="secondary" />}</ListItemIcon>
                    <ListItemText primary={'1 number,'} />
                </ListItem>
                <ListItem >
                    <ListItemIcon>{hasSpecialCharacter(password) ? <CheckCircleIcon className={classes.greenTick} /> : <FiberManualRecordIcon color="secondary" />}</ListItemIcon>
                    <ListItemText primary={'At least one special character'} />
                </ListItem>
                <ListItem >
                    <ListItemIcon />
                    <ListItemText primary={'! @ # $ % ^ & * ( ) _ - +'} />
                </ListItem>
            </List>
        </Box>
    );
}

const PasswordTooltip = props => {
    const { children } = props;
    return (
        <HtmlTooltip arrow title={getPassowrdToolTip(children.props.value, props.email)} enterTouchDelay={0}>
            {children}
        </HtmlTooltip>
    );
}

export default PasswordTooltip;